"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vizzola-ticino": {
    "6943f954": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "barbelera": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ccf70fa6": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "bonifica-caproni": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a2ae1fc": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "castelnovate": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c79fc647": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "le-palazzine": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "893a8fd7": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "molino-di-ferno": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2382a9a8": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "piane-di-modro": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07d84cbf": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "pineta-fugazza": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a68f8939": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "skipSearch": false
    }],
    "sera": [{
      "hkey": "4fdda10c",
      "slug": "vizzola-ticino",
      "name": "Vizzola Ticino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;